const getIsFreeUserForEnrollMessage = (
  myInfo: object | null | undefined,
  goalUID: string | undefined,
  isPlusIconicSubscribed: boolean
) => {
  if (!myInfo || !goalUID) {
    return false;
  }

  if (isPlusIconicSubscribed) {
    return false;
  }

  return true;
};

export default getIsFreeUserForEnrollMessage;
